import { Pipe, PipeTransform } from '@angular/core';
import { formatPhoneNumberForDisplay } from '@shared/utils/phone-number-format.util';

@Pipe({
  name: 'phoneNumber',
  standalone: true,
})
export class PhoneNumberPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return formatPhoneNumberForDisplay(value) ?? value ?? '';
  }
}
